import { SxProps, Theme } from "@mui/material";

export const addFamilyMemberButtonContainer = (
  isSelected: boolean
): SxProps<Theme> => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "10px",
  padding: "16px",
  borderRadius: "10px",
  background: "#FFF",
  boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.10)",
  border: isSelected ? "3px solid #F7B500" : "0.5px solid #E5E5E5",
  cursor: "pointer",
  "&:hover": {
    background: "#FFF3E7",
  },
});

export const addFamilyMemberButtonText: SxProps<Theme> = {
  fontFamily: "Roboto Condensed",
  fontSize: "20.1px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "normal",
  color: "#000",
  textAlign: "center",
};

export const dotBox: SxProps<Theme> = {
  width: "10px",
};
